export const totalMeetImages = 39;

export const assetList = [
  // {
  //   type: "video",
  //   name: "showreel",
  //   file: "/video/showreel.mp4",
  // },

  {
    type: "image",
    name: "arrowLight",
    file: "/images/arrow_light.png",
  },
  {
    type: "image",
    name: "simplexNoise",
    file: "/images/noise-simplex.jpeg",
  },
  // Service images
  {
    type: "image",
    name: "serviceCampaign",
    file: "/images/services/campaign.webp",
    flipY: true,
  },
  {
    type: "image",
    name: "serviceIdentity",
    file: "/images/services/identity.webp",
    flipY: true,
  },
  {
    type: "image",
    name: "serviceWebdesign",
    file: "/images/services/web-design.webp",
    flipY: true,
  },
  {
    type: "image",
    name: "servicePhotoVideo",
    file: "/images/services/photo-video.webp",
    flipY: true,
  },
  {
    type: "image",
    name: "serviceStrategy",
    file: "/images/services/strategy.webp",
    flipY: true,
  },
];
